import React from "react";
import SectionHeadline from "./SectionHeadline";
import img3 from "../assets/slider3.jpeg";
import hol1 from "../assets/hol1.jpg";
import hol2 from "../assets/hol2.jpg";
import hol3 from "../assets/hol3.jpg";
import hol4 from "../assets/hol4.jpg";
import hol5 from "../assets/hol5.jpg";
import g1 from "../assets/g1.jpg";
import g2 from "../assets/g2.jpg";
import g3 from "../assets/g3.jpg";
import g4 from "../assets/g4.jpg";
import g5 from "../assets/g5.jpg";
import g6 from "../assets/g6.jpg";
import g7 from "../assets/g7.jpg";
import g8 from "../assets/g8.jpg";

const ImageGallery = () => {
  // Array of image URLs

  const imageUrls = [
    hol1,
    hol2,
    hol3,
    hol4,
    hol5,
    g1,
    g2,
    g3,
    g4,
    g5,
    g6,
    g7,
    g8,
  ];

  return (
    <div className="  md:px-0 px-4 flex flex-col gap-10 justify-center items-center">
      <div className=" w-full md:w-10/12">
        <SectionHeadline title="  Image Gallery" backgroundImage={img3} />
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mt-14">
          {imageUrls.map((url, index) => (
            <div
              key={index}
              className="relative verflow-hidden bg-cover group bg-no-repeat"
              data-twe-ripple-init
              data-twe-ripple-color="light"
            >
              <img
                src={url}
                className=" rounded-md h-96 w-96 object-cover  duration-500 group-hover:translate-y-px"
                alt={`img ${index}`}
              />

              <div className="absolute bottom-0 left-0 right-0 top-0 h-full w-full overflow-hidden bg-[hsl(0,0%,98.4%,0.2)] bg-fixed opacity-0 transition duration-300 ease-in-out hover:opacity-100"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageGallery;
